/* eslint-disable no-nested-ternary */
/* eslint-disable prettier/prettier */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-alert */
/* eslint-disable react/display-name */
/* eslint-disable react/button-has-type */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import { formatCurrency } from '@brazilian-utils/brazilian-utils';
import * as React from 'react';
import { FiXCircle } from 'react-icons/fi';
import Paper from '@material-ui/core/Paper';
import ModalTicket from '../../../components/ModalTicket';
import { useToast } from '../../../hooks/toast';
import Loader from '../../../components/Loader';
import api from '../../../services/api';
import { Buttons, DivPrincipal, Main } from './styles';
import Button from '../../../components/Button';
import { TableMap } from './tableMapHistory';

const MapHistory: React.FC<any> = () => {
  const [mapHistory, setMapHistory] = React.useState<any[]>([]);
  const [ticket, setTicket] = React.useState<any>(false);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [hasData, setHasData] = React.useState<boolean>(true);
  const [botao1, setBotao1] = React.useState<boolean>(false);
  const [botao2, setBotao2] = React.useState<boolean>(true);
  const [botao3, setBotao3] = React.useState<boolean>(true);
  const [botao4, setBotao4] = React.useState<boolean>(true);
  const { addToast } = useToast();

  const convertStringToDate = (dataHoraEvento: any) => {
    if (!dataHoraEvento) {
      return '2';
    }

    const [date, time] = dataHoraEvento.split(' ');
    const [day, month, year] = date.split('/').map(Number);
    const [hours, minutes, seconds] = time.split(':').map(Number);
    return new Date(day, month - 1, year, hours, minutes, seconds);
  };

  const getMapHistory = React.useCallback(async () => {
    try {
      setBotao1(false);
      setBotao2(true);
      setBotao3(true);
      setBotao4(true);
      setLoading(true);
      
      const date90DaysAgo = new Date();
      date90DaysAgo.setDate(date90DaysAgo.getDate() - 90);
      const startDate = date90DaysAgo.toISOString().split('T')[0];

      const { data } = await api.get(
        `/ticketing/qr-code/map/?start_date=${startDate}`,
      );

      const conteudo = Array.isArray(data?.conteudo) ? data.conteudo : [];
      const newData = conteudo.filter((dados: any) => dados?.codigoQRCode !== null);

      if (newData.length > 0) {
        setMapHistory(newData);
        setHasData(true);
      } else {
        setMapHistory([]);
        setHasData(false);
      }
    } catch (e) {
      console.log({ e });
      setHasData(false);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleDisponiveis = React.useCallback(async () => {
    try {
      setBotao1(true);
      setBotao2(false);
      setBotao3(true);
      setBotao4(true);
      setMapHistory([]);
      setLoading(true);

      const date90DaysAgo = new Date();
      date90DaysAgo.setDate(date90DaysAgo.getDate() - 90);
      const startDate = date90DaysAgo.toISOString().split('T')[0];

      const { data } = await api.get(
        `/ticketing/qr-code/map/?start_date=${startDate}`,
      );

      const conteudo = Array.isArray(data?.conteudo) ? data.conteudo : [];
      const newData = conteudo.filter((dados: any) => dados?.codigoQRCode !== null);
      const datadisp = newData.filter((dados: any) => Number(dados?.statusUso) === 0);

      if (datadisp.length > 0) {
        setMapHistory(datadisp);
        setHasData(true);
      } else {
        setMapHistory([]);
        setHasData(false);
      }
    } catch (e) {
      console.log({ e });
      setHasData(false);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleExp = React.useCallback(async () => {
    try {
      setBotao1(true);
      setBotao2(true);
      setBotao3(false);
      setBotao4(true);
      setMapHistory([]);
      setLoading(true);

      const date90DaysAgo = new Date();
      date90DaysAgo.setDate(date90DaysAgo.getDate() - 90);
      const startDate = date90DaysAgo.toISOString().split('T')[0];

      const { data } = await api.get(
        `/ticketing/qr-code/map/?start_date=${startDate}`,
      );

      const conteudo = Array.isArray(data?.conteudo) ? data.conteudo : [];
      const newData = conteudo.filter((dados: any) => dados?.codigoQRCode !== null);
      const datadisp = newData.filter(
        (dados: any) => Number(dados?.statusUso) === 2 || Number(dados?.statusUso) === 3
      );

      if (datadisp.length > 0) {
        setMapHistory(datadisp);
        setHasData(true);
      } else {
        setMapHistory([]);
        setHasData(false);
      }
    } catch (e) {
      console.log({ e });
      setHasData(false);
      addToast({
        type: 'error',
        title: 'Erro Ticket',
        description: 'Erro Ticket!',
      });
    } finally {
      setLoading(false);
    }
  }, []);

  const handleUtil = React.useCallback(async () => {
    try {
      setBotao1(true);
      setBotao2(true);
      setBotao3(true);
      setBotao4(false);
      setMapHistory([]);
      setLoading(true);

      const date90DaysAgo = new Date();
      date90DaysAgo.setDate(date90DaysAgo.getDate() - 90);
      const startDate = date90DaysAgo.toISOString().split('T')[0];

      const { data } = await api.get(
        `/ticketing/qr-code/map/?start_date=${startDate}`,
      );

      const conteudo = Array.isArray(data?.conteudo) ? data.conteudo : [];
      const newData = conteudo.filter((dados: any) => dados?.codigoQRCode !== null);
      const datadisp = newData.filter((dados: any) => Number(dados?.statusUso) === 1);

      if (datadisp.length > 0) {
        setMapHistory(datadisp);
        setHasData(true);
      } else {
        setMapHistory([]);
        setHasData(false);
      }
    } catch (e) {
      console.log({ e });
      setHasData(false);
      addToast({
        type: 'error',
        title: 'Erro Ticket',
        description: 'Erro Ticket!',
      });
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    getMapHistory();
  }, []);

  return (
    <DivPrincipal>
      <h1 className="datatext">Histórico de QrCodes</h1>
      <div className="botoes">
        <Button
          color={botao1 ? 'var(--orange)' : 'var(--purple)'}
          padding="3.5"
          rounded
          className="button-cadastrar"
          type="submit"
          onClick={getMapHistory}
          style={{
            backgroundColor: botao1 ? 'var(--orange)' : 'var(--purple)',
          }}
        >
          TODOS
        </Button>
        <Button
          color={botao2 ? 'var(--orange)' : 'var(--purple)'}
          padding="3.5"
          rounded
          className="button-cadastrar"
          type="submit"
          style={{
            backgroundColor: botao2 ? 'var(--orange)' : 'var(--purple)',
          }}
          onClick={handleDisponiveis}
        >
          DISPONÍVEIS
        </Button>
        <Button
          color={botao3 ? 'var(--orange)' : 'var(--purple)'}
          padding="3.5"
          rounded
          className="button-cadastrar"
          type="submit"
          style={{
            backgroundColor: botao3 ? 'var(--orange)' : 'var(--purple)',
          }}
          onClick={handleExp}
        >
          EXPIRADOS
        </Button>
        <Button
          color={botao4 ? 'var(--orange)' : 'var(--purple)'}
          padding="3.5"
          rounded
          className="button-cadastrar"
          type="submit"
          style={{
            backgroundColor: botao4 ? 'var(--orange)' : 'var(--purple)',
          }}
          onClick={handleUtil}
        >
          UTILIZADOS
        </Button>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <Main>
          {hasData && mapHistory?.length > 0 ? (
            <Paper className="paper">
              <div className="Tabela">
                <TableMap
                  title=""
                  columns={[
                    {
                      name: 'Código QRCode',
                      selector: 'codigoqrcode',
                      cell: ({ codigoQRCode }: any) => (
                        <div className="specifitcell">{codigoQRCode}</div>
                      ),
                    },
                    {
                      name: 'Linha',
                      selector: 'linha',
                      cell: ({ linha }: any) => (
                        <div className="specifitcell">{linha}</div>
                      ),
                    },
                    {
                      name: 'Valor',
                      selector: 'valor',
                      cell: ({ valor }: any) => (
                        <div className="specifitcell">{`R$ ${formatCurrency(
                          Number(valor),
                        )}`}</div>
                      ),
                    },
                    {
                      name: 'Data da compra',
                      selector: 'datacompra',
                      cell: ({ dataHoraEvento }: any) => (
                        <div className="specifitcell">{dataHoraEvento}</div>
                      ),
                    },
                    {
                      name: (
                        <span
                          title="Apenas em casos de não utilizados"
                          className="table-help"
                        >
                          Data do Reembolso
                        </span>
                      ),
                      selector: 'dataHoraRessarcimento',
                      cell: ({ dataHoraRessarcimento }: any) => (
                        <div className="specifitcell">{dataHoraRessarcimento}</div>
                      ),
                    },
                    {
                      name: 'Ações / Status',
                      selector: (row: any) => {
                        if (!row?.codigoQRCode) return null;

                        switch (Number(row?.statusUso)) {
                          case 0:
                            return (
                              <Buttons
                                onClick={async () => {
                                  try {
                                    setLoading(true);
                                    const response = await api.get(
                                      `/ticketing/qr-code/reissue-ticket-by-value/${row?.codigoQRCode}/ `,
                                    );
                                    setTicket({
                                      code: row?.codigoQRCode,
                                      line: row?.linha,
                                      value: Number(row?.valor),
                                      image: response?.data?.imagemBase64,
                                      dataHora:
                                        response?.data?.dataHoraFimValidadeCarga,
                                      tempoExpiracao:
                                        response?.data?.tempo_expiracao,
                                    });
                                  } catch (e) {
                                    console.log({ e });
                                    setTicket(undefined);
                                  } finally {
                                    setLoading(false);
                                  }
                                }}
                              >
                                Visualizar ticket
                              </Buttons>
                            );
                          case 1:
                            return <p> UTILIZADO </p>;
                          case 2:
                            return <p> EXPIRADO </p>;
                          case 3:
                            return <p> REEMBOLSADO </p>;
                          case 4:
                            return <p> ESTORNO REEMBOLSO </p>;
                          default:
                            return null;
                        }
                      },
                    },
                  ]}
                  data={mapHistory}
                />
              </div>
            </Paper>
          ) : (
            <div className="nodata">
              <FiXCircle size={80} className="icon" />
              <h3 className="infonotdata">
                Sem dados disponíveis para o filtro selecionado.
              </h3>
            </div>
          )}
        </Main>
      )}

      {ticket && (
        <ModalTicket
          code={ticket?.code}
          line={ticket?.line}
          value={ticket?.value}
          closeModal={() => setTicket(undefined)}
          image={ticket?.image}
          dataValidade={ticket?.dataHora}
          tempoExpiracao={ticket?.tempoExpiracao}
          gerando
        />
      )}
    </DivPrincipal>
  );
};

export { MapHistory };
